import { Component, OnInit, Inject, Optional, NgModule, inject } from '@angular/core';
import { POPOVER_DATA } from '../../popover/popover.service';
import { PopoverRef } from '../../popover/popover-ref';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'tt-popover-msg',
  imports: [
    MatButtonModule,
    MatIconModule,
    TranslateModule
  ],
  templateUrl: './popover-msg.component.html',
  styleUrls: ['./popover-msg.component.css'],
  standalone: true
})
export class PopoverMsgComponent {
   public data = inject<any>(POPOVER_DATA);
  constructor(
    private popoverRef: PopoverRef<string>,
   
  ) { }
  closeManually(): void {
    this.popoverRef.close();
  }

}
